import { jsx as _jsx } from "react/jsx-runtime";
import { SimpleOverlayTable } from '../SimpleOverlayTable';
import { GetProjections } from './GetProjections';
var numbersWithCommas = function (number) {
    if (number >= 1000) {
        return number
            .toString()
            .replace(/,/g, '')
            .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    return number;
};
var beautifyNumbers = function (number) {
    return numbersWithCommas(number);
};
export var ProjectionTable = function (_a) {
    var estimateMiles = _a.estimateMiles, calculatePrices = _a.calculatePrices;
    var estimates = GetProjections({ estimateMiles: estimateMiles, calculatePrices: calculatePrices });
    var prettyEstimates = estimates
        .map(function (number) {
        return {
            estimateMiles: beautifyNumbers(number.estimateMiles),
            active: number.active || false,
            estimateCost: number.estimateCost.toFixed(2),
        };
    })
        .filter(function (item) { return (item === null || item === void 0 ? void 0 : item.length) !== 0; });
    return (_jsx(SimpleOverlayTable, { mileageTitle: "annual mileage", costTitle: "projected overall cost", prettyEstimates: prettyEstimates }));
};
